<template>
  <ValidationObserver v-slot="{ invalid }">
    <ConfirmModal
      :primary-button-text="$t('user.confirm')"
      :cancel-button-text="$t('core.cancel')"
      :is-primary-button-disabled="invalid"
      :confirm-fn="onConfirm"
    >
      <template #header>
        <div class="has-text-centered is-full-width has-text-weight-medium">
          <h1 class="is-size-3 has-text-weight-medium">
            {{ $t('user.input-your-address') }}
          </h1>
          <p class="is-size-5 m-t-10">
            {{ $t('user.please-provide-address') }}
          </p>
        </div>
      </template>
      <template #body>
        <FormAddress v-model="user.contact.address" />
      </template>
    </ConfirmModal>
  </ValidationObserver>
</template>

<script>
import { User } from '@/modules/user/models/User';
import ValidationObserver from '/@/modules/core/form/components/ValidationObserver.vue';
import { ModalMixin } from '/@/modules/core/ui/mixins/ModalMixin';
import FormAddress from '@/modules/core/form/components/FormAddress.vue';
import ConfirmModal from '/@/modules/core/ui/components/ConfirmModal.vue';
import UserService from '@/modules/user/services/UserService';
import AuthService from '@/modules/auth/services/AuthService';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'UserAddAddressModal',
  emits: ['address-updated'],
  mixins: [ModalMixin],
  components: {
    ConfirmModal,
    FormAddress,
    ValidationObserver
  },
  props: {
    value: {
      type: User,
      required: true
    }
  },
  data() {
    return {
      user: null
    };
  },
  methods: {
    async onConfirm() {
      this.user = await UserService.saveEntity(this.user, this.user.id);
      await AuthService.refreshAuthUser();
      this.$emit('address-updated');
      this.close();
    }
  },
  created() {
    this.user = this.value;
  }
};
</script>
